import { createAlgoliaFilters, AlgoliaFilterOperator } from "../../../../../../CrossSellProducts/utils/CrossSellProducts/utils/create-algolia-filters.js";
import { queryStringToQueryObject } from "../../../../../utils/Algolia/utils/query-string.js";
function createFiltersFromSkus(skus) {
  if (skus.length === 0) {
    return "";
  }
  const filterableSkus = skus.filter(Boolean).map((sku) => ({
    id: "masterVariant.sku",
    value: sku
  }));
  return createAlgoliaFilters(filterableSkus, AlgoliaFilterOperator.OR);
}
function createFiltersFromQuery(query, facets) {
  if (!query || !facets) {
    return "";
  }
  const queryObject = queryStringToQueryObject(query, { facets });
  const filterableAttributes = Object.keys(queryObject).map((filterKey) => {
    const attribute = facets?.find((facet) => facet.id === filterKey);
    const value = queryObject[filterKey];
    if (!attribute || !attribute.attribute) {
      return null;
    }
    return {
      id: attribute.attribute,
      value
    };
  }).filter((val) => val !== null && Boolean(val.id));
  return createAlgoliaFilters(filterableAttributes, AlgoliaFilterOperator.AND);
}
export {
  createFiltersFromQuery,
  createFiltersFromSkus
};
//# sourceMappingURL=utils.js.map
